import React from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { SetupBanner } from './SetupBanner';

export function AppLayout({ children }) {
    return (
        <div className="flex min-h-screen w-full bg-background">
            <a
                href="#main-content"
                className="skip-link"
            >
                Skip to main content
            </a>

            <Sidebar className="hidden lg:block fixed left-0 top-0 bottom-0 z-40" />

            <div className="flex flex-col flex-1 lg:pl-64">
                <SetupBanner />
                <TopBar />
                <main
                    id="main-content"
                    className="flex-1 p-4 md:p-6 pt-6"
                    role="main"
                    aria-label="Main content"
                >
                    <div className="mx-auto w-full max-w-[1600px] space-y-4">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
}
